import { apiFetch } from "@/lib/api-client";
import type { PublicUser, WorkspaceSummary } from "@/types/auth";

export type AuthResponse = { token: string; user: PublicUser; workspaces: WorkspaceSummary[] };
export type MeResponse = { user: PublicUser; workspaces: WorkspaceSummary[] };

export const login = (body: { email: string; password: string }) =>
	apiFetch<AuthResponse>("/auth/login", {
		method: "POST",
		body: JSON.stringify(body),
		auth: false,
	});

export const signup = (body: { name: string; email: string; password: string }) =>
	apiFetch<AuthResponse>("/auth/signup", {
		method: "POST",
		body: JSON.stringify(body),
		auth: false,
	});

export const getMe = () => apiFetch<MeResponse>("/auth/me");
